/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({
  routeId,
  routePlanId,
  routePlanIds,
  onRoutePlanUpdate,
  onRoutePlanDelete,
  PassOnUpdate,
  selectedIds
}) => {
  // Hook assignment.
  const [_anchorEl, _setAnchorEl] = React.useState(null)
  const _open = Boolean(_anchorEl)

  const _handleClick = (event) => {
    _setAnchorEl(event.currentTarget)
  }

  const _handleClose = () => {
    _setAnchorEl(null)
  }

  // Return component.
  return (
    <>
      <IconButton
        onClick={_handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          backgroundColor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            // Push route id to url.
            PassOnUpdate({ routePlanIds, routePlanId, routeId })

            // Execute handler.
            onRoutePlanUpdate(selectedIds)

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiPencil size={18} />
          <span>Edit CBR Route Plan</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push route id to url.
            PassOnUpdate({ routePlanIds, routePlanId, routeId })

            // Execute handler.
            onRoutePlanDelete(selectedIds)

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiTrash size={18} />
          <span>Delete CBR Route Plan</span>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'routeId': PropTypes.string,
  'routePlanId': PropTypes.string,
  'routePlanIds': PropTypes.arrayOf(PropTypes.string),
  'onRoutePlanUpdate': PropTypes.func,
  'onRoutePlanDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func,
  'selectedIds': PropTypes.array
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
